// Copyright (c) 2016 Deere & Company

import actions from '../../../part-requests/actions-list';
import {getDefaultState} from '../state/';

const decreaseBusyCounter = state => state - 1;

const increaseBusyCounter = state => state + 1;

export default (state = getDefaultState().busyCounter, action) => {

    const actionTypes = {
        [actions.DECREASE_PART_REQUESTS_SEARCH_BUSY_COUNTER]: decreaseBusyCounter,
        [actions.INCREASE_PART_REQUESTS_SEARCH_BUSY_COUNTER]: increaseBusyCounter
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/part-requests/search/reducers/busy-counter.js